import { createContext } from 'react'

import type { EventsContextValue } from './events-context.interface'

export const EventsContext = createContext<EventsContextValue>({
  activeEvents: [],
  setActiveEvents: () => {},
})
